export default "__VITE_ASSET__cf581888__"